import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import principle03 from "./layouts/principle-03/principle";
import principle04 from "./layouts/principle-04/principle";
import principle05 from "./layouts/principle-05/principle";

const lesson: Lesson = {
  id: "0e068889-b0f3-4edd-9222-a582ddf1a96b",
  publicId: "32",
  name: "Measurement of the attenuation index of a panel using intensimetry",
  showHeaderNavigation: true,
  difficulty: 2,
  body: [principle01, principle02, principle03, principle04, principle05],
};

export default lesson;
